export const STRATEGY_CHAT = {
    "errorOnChatAdministratorsList": function (json) {
        if (typeof errorOnChatAdministratorsList === 'function') {
            errorOnChatAdministratorsList(json.data);
        }
    },
    "ChatHistory": function (json) {
        if (typeof onChatHistory === 'function') {
            onChatHistory(json.data);
        }
    },
    "NewMessage": function (json) {
        if (typeof onChatMessage === 'function') {
            onChatMessage(json.data);
        }
    },
    "SupervisorsToChat": function (json) {
        if (typeof onAdministrators === 'function') {
            onAdministrators(json.data);
        }
    },
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyChat.js